/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from './Footer';
import Backdrop from './Backdrop';
import '../styles.css';

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    {wordpressSiteMetadata {
    name
    description
  }}
  `)

  return (
    <>
      <Header siteTitle={data.wordpressSiteMetadata.name} desc={data.wordpressSiteMetadata.description} />
      <div
      >
        <main>{children}
        <Footer />
        </main>
        
        <Backdrop />
      </div>
      
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
